<app-loader></app-loader>
<div class="d-flex">
  <div class="case-wrapper w-50 p-5">
    <div class="logo-bar position-relative">
      <div class="container" *ngIf="appLogo?.length > 0">
        <img class="logo mb-2" src="{{appLogo}}" alt=""><br /><br />
      </div>
      <div class="top-right-menu">
        <button *ngIf="!checkIfMobile()" mat-button class="qr-code-button" id="qrCode" (click)="openDialog()">
          <img class="" src="{{qrIcon}}" width="35" height="35" alt="">
        </button>
        <mat-select id="langSelector" [(value)]="langSelected" (selectionChange)="changeLanguage(langSelected)">
          <mat-option value="nl_BE">NL</mat-option>
          <mat-option value="en_US">EN</mat-option>
        </mat-select>
      </div>

    </div>
    <section id="main" class="main" fxLayout='row'>
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </section>
  </div>
</div>
